import { FC } from "react";
import classNames from "classnames";
import { ScanPageContentCustomProps, ScanPageContentItemEnum, } from "../../interface";
/** 自定义主体内容 */
const Custom: FC<ScanPageContentCustomProps> = props => {
  const { className, style, children, title, addonAfter, addonBefore, } = props;
  const classes = classNames('body-content-custom', className);
  return (
    <div className={classes} style={style}>
      <div className="body-content-custom-header">
        <div className="count-header-left yb-card-item-head">
          {addonBefore}
          <div className="count-header-left-title">{title}</div>
        </div>
        <div>{addonAfter}</div>
      </div>
      <div className='body-content-custom-body'>
        {children}
      </div>
    </div>
  );
};

Custom.displayName = ScanPageContentItemEnum.ContentCustom;

export default Custom;